module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"flex flex-column\">\n    <div class=\"flex-none flex flex-row\">\n        <div class=\"flex-item\">\n			<input type=\"text\" placeholder=\"Введите кадастровый номер\">\n        </div>\n        <div class=\"flex-none flex flex-row\">\n            <button name=\"info\" class=\"ctrl-cadastre-info flex-item\" style=\"display:none;\" title=\"Информация о кадастровом номере\">\n                <div class=\"icon-21 icon-info-circle\" style=\"color:#ffffff\"></div>\n            </button>\n            <button name=\"select\" class=\"ctrl-cadastre-select flex-item\" title=\"Выбрать на карте\">\n                <div class=\"icon-21 icon-map\" style=\"color:#ffffff\"></div>\n            </button>\n        </div>\n    </div>\n</div>\n")
  }
  return __output.join("");

}